export const FETCH_ORG_DATA_START = 'FETCH_ORG_DATA_START';
export const FETCH_ORG_DATA_FULFILLED = 'FETCH_ORG_DATA_FULFILLED';
export const FETCH_ORG_DATA_REJECTED = 'FETCH_ORG_DATA_REJECTED';

export const JOIN_ORG_START = 'JOIN_ORG_START';
export const JOIN_ORG_FULFILLED = 'JOIN_ORG_FULFILLED';
export const JOIN_ORG_REJECTED = 'JOIN_ORG_REJECTED';

export const LOAD_NEW_ORG_START = 'LOAD_NEW_ORG_START';
export const LOAD_NEW_ORG_FULFILLED = 'LOAD_NEW_ORG_FULFILLED';
export const LOAD_NEW_ORG_REJECTED = 'LOAD_NEW_ORG_REJECTED';
